import { ChangeDetectionStrategy, Component, Input, input } from '@angular/core';

@Component({
  selector: 'rt-label',
  templateUrl: './label.component.html',
  styleUrls: ['./label.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-font-weight-normal]': 'hasFontWeightNormal()',
    '[class.has-font-weight-medium]': 'hasFontWeightMedium()',
    '[class.has-color-default]': 'hasColorDefault()',
    '[class.has-color-red]': 'hasColorRed()',
    '[class.has-required-badge]': 'hasRequiredBadge()',
    '[class.has-font-size-large]': 'hasFontSizeLarge()',
    '[class.has-description]': '!!description',
  },
  imports: [],
})
export class LabelComponent {
  public readonly hasFontWeightNormal = input<boolean>(false);
  public readonly hasFontWeightMedium = input<boolean>(false);
  public readonly hasColorDefault = input<boolean>(false);
  public readonly hasColorRed = input<boolean>(false);
  public readonly hasRequiredBadge = input<boolean>(false);
  public readonly hasFontSizeLarge = input<boolean>(false);
  public readonly clickable = input<boolean>(false);
  @Input() public description: string = '';
}
